$(document).ready(function () {
  var $block = $('.three-highlights-block');
  $block.find('[data-collapse-trigger]').click(function () {
    if (window.innerWidth < 1200) {
      var $triggeredEl = $(this).siblings('[data-collapsible-content]');
      var $openEl = $block.find('.three-highlights-block__card.open');
      if ($openEl.length) {
        $openEl.find('[data-collapsible-content]').toggle('fast', function () {
          $openEl.removeClass('open');
          if (!$openEl.find($triggeredEl).length) {
            open($triggeredEl);
          }
        });
      }
      else {
        open($triggeredEl);
      }
    }
  });

  function open($el) {
    $el.toggle('fast', function () {
      $el.parents('.three-highlights-block__card').addClass('open');
    });
  }
})